import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { RouterModule } from '@angular/router'; 
import { XRackSharedModule } from './shared/x-rack-shared.module';
// import { AmplifyService } from 'aws-amplify-angular';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    // LayoutModule
    LayoutModule,
    RouterModule,
    XRackSharedModule
  ],
  providers: [
    // AmplifyService
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
